import * as React from 'react'

import TourSelectionCard from './tour_selection_card'
import { ELEMENTARY_AND_MIDDLE_SCHOOL_ELA, ENGLISH_LEARNERS, HIGH_SCHOOL_ELA, SOCIAL_STUDIES, } from './constants'
import { 
  CHILD_RAISING_PENCIL, 
  QUILL_CONNECT_BEZEL, 
  QUILL_LOGO, 
  STUDENT_READING_ILLUSTRATION 
} from './asset_constants'

const introSlide = (
  <section className="slide introduction-slide intro-slide" key="intro-slide">
    <h1>You're here to build better writers. We're here to help.</h1>
    <img alt="" src={STUDENT_READING_ILLUSTRATION} />
    <p>Our non-profit mission is to help all students become strong readers, writers, and critical thinkers.</p>
    <p>By signing up for Quill, you now have access to <b>1,000+ literacy activities — all free, forever.</b></p>
    <img alt="" src={QUILL_LOGO} />
  </section>
)

const getFreePremiumSlide = (
  <section className="slide introduction-slide get-free-premium-slide" key="get-free-premium">
    <h1>Take the tour and we’ll give you 30 days of Quill Premium—Free!</h1>
    <img alt="" src={CHILD_RAISING_PENCIL} />
    <div className="paragraphs-wrapper">
      <p>We’re a <b>small non-profit team</b> with a big mission: to equip you with powerful tools so that your students can strengthen their literacy skills. Quill exists to support <b>teachers like you</b>.</p>
      <p>We created this tour to help you understand how to best use our tools. Complete it and we will provide an additional free month of Quill Premium as a thank you for your time.</p>
      <p className="quill-gold-dark"><b>Finish the tour to unlock Quill Premium!</b></p>
    </div>
  </section>
)

const literacyToolsSlide = (
  <section className="slide introduction-slide literacy-tools-slide" key="literacy-tools-slide">
    <h1>Quill equips you with powerful literacy tools</h1>
    <div className="cards-wrapper">
      <section className="learning-to-write">
        <div className="card-header">
          <h2>
            <span>Grades 4-12</span>
            <span>Learning to Write</span>
          </h2>
          <p>Students complete sentence writing prompts to strengthen <b>syntax, language, and grammar</b> skills.</p>
        </div>
        <div className="word-cloud-and-text-container">
          <section className="word-cloud-container">
            <h3>Build literacy skills</h3>
            <ul className="word-cloud">
              <li>Capitalization</li>
              <li>Prepositions</li>
              <li>Commonly Confused Words</li>
              <li>Commas</li>
              <li>Adverbs</li>
              <li>Adjectives</li>
              <li>Pronouns</li>
              <li>Compound Sentences</li>
              <li>Articles</li>
              <li>Contractions</li>
              <li>Possessive Nouns</li>
            </ul>
          </section>
        </div>
      </section>
      <section className="writing-to-learn">
        <div className="card-header">
          <h2>
            <span>Grades 8-12</span>
            <span>Writing to Learn</span>
          </h2>
          <p>Students read nonfiction texts and respond to open-ended prompts to strengthen their <b>content knowledge, informational writing, and reading comprehension</b> skills.</p>
        </div>
        <div className="word-cloud-and-text-container">
          <section className="word-cloud-container">
            <h3>Build content knowledge</h3>
            <ul className="word-cloud">
              <li>ELA Culture & Society</li>
              <li>ELA Literature</li>
              <li>Interdisciplinary Science: AI Literacy</li>
              <li>World History: 1750 to the Present</li>
              <li>World History: 1200 to the Present</li>
            </ul>
          </section>
        </div>
      </section>
    </div>
  </section>
)

const strengthenWritingSkillsSlide = (
  <section className="slide introduction-slide strengthen-writing-skills-slide" key="strengthen-writing-skills-slide">
    <h1>Quill strengthens your students’ writing skills</h1>
    <div className="flex-wrapper">
      <div className="img-wrapper">
        <img alt="" src={QUILL_CONNECT_BEZEL} />
      </div>
      <div className="text">
        <p>Teachers assign weekly Quill practice activities that <b>immediately grade</b> student writing.</p>
        <p>As students write, Quill provides <b>targeted feedback and coaching</b> to help them refine and improve their sentences.</p>
        <p>This <b>write-and-revise loop</b> repeats up to five times, allowing students to reflect and grow with every revision.</p>
        <p>Teachers save <b>hundreds of hours per year</b> spent grading writing assignments.</p>
      </div>
    </div>
  </section>
)

const selectTourSlide = (setTour) => {
  return (
    <section className="slide introduction-slide select-tour-slide" key="select-tour-slide">
      <h1>Select Your Tour</h1>
      <p>Learn how Quill serves different classrooms</p>
      <div className="flex-wrapper">
        <TourSelectionCard
          id={ELEMENTARY_AND_MIDDLE_SCHOOL_ELA}
          selectTour={setTour}
        />
        <TourSelectionCard
          id={ENGLISH_LEARNERS}
          selectTour={setTour}
        />
        <TourSelectionCard
          id={HIGH_SCHOOL_ELA}
          selectTour={setTour}
        />
        <TourSelectionCard
          id={SOCIAL_STUDIES}
          selectTour={setTour}
        />
      </div>
    </section>
  )
}

const introductionSlides = ({ setTour, }) => [
  introSlide,
  getFreePremiumSlide,
  literacyToolsSlide,
  strengthenWritingSkillsSlide,
  selectTourSlide(setTour)
]

export default introductionSlides
